const { fetchJSON } = window.BAO.Utils

class HarperCta extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()

    const userCity = await this.getUserCity()

    const lowercaseCities = this?.dataset?.cities?.toLowerCase() || 'london'
    const citiesArray = lowercaseCities.split(',')
    const isCityInList = citiesArray.includes(userCity)

    if (!isCityInList) return

    this.showCta()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.trigger?.exists) {
      this.els.trigger.elements.forEach(el => {
        el.addEventListener('click', this.onClick.bind(this))
      })
    }
  }

  showCta () {
    this.setAttribute('aria-hidden', 'false')

    if (this.externalEls?.message?.exists) {
      this.externalEls.message.elements.forEach(el => {
        el.setAttribute('aria-hidden', 'true')
      })
    }
  }

  onClick () {
    if (document.querySelector('[data-product-add-to-cart]')) {
      document.querySelector('[data-product-add-to-cart]').click()
    }
  }

  getUserCity () {
    if (
      window.sessionStorage.getItem(this.sessionStorageName) !== undefined &&
      window.sessionStorage.getItem(this.sessionStorageName) !== null
    ) {
      return window.sessionStorage
        .getItem(this.sessionStorageName)
        .toLowerCase()
    }

    return fetchJSON(
      `https://api.ipgeolocation.io/ipgeo?apiKey=${this.apiKey}&fields=city`,
      { method: 'GET' },
    ).then(res => {
      window.sessionStorage.setItem(
        this.sessionStorageName,
        res.city.toLowerCase(),
      )
      return res.city.toLowerCase()
    })
  }

  get apiKey () {
    return 'ad9951763a9e4db793251dfae7379bd8'
  }

  get sessionStorageName () {
    return 'bao-user-city'
  }
}

if (!customElements.get('harper-cta')) {
  customElements.define('harper-cta', HarperCta)
}
